import { render } from "./WithdrawRequestComponent.vue?vue&type=template&id=15610dc3&scoped=true"
import script from "./WithdrawRequestComponent.vue?vue&type=script&lang=js"
export * from "./WithdrawRequestComponent.vue?vue&type=script&lang=js"

import "./WithdrawRequestComponent.vue?vue&type=style&index=0&id=15610dc3&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15610dc3"]])

export default __exports__